import React from 'react';

import FieldTableHeader from 'registry/field/FieldTableHeader';

import {StudySchemaQuery_studySchema_StudySchemaNode_entryTemplates as EntryTemplateIconOrInaccessibleInfo} from './__generated/StudySchemaQuery';
import TagEntryTemplates from './TagEntryTemplates';

export interface StudySchemaEntryTemplatesProps {
  entryTemplates: Array<EntryTemplateIconOrInaccessibleInfo>;
  onAddClick: () => void;
  writable: boolean;
}

export default function StudySchemaEntryTemplatesTable({
  entryTemplates,
  onAddClick,
  writable,
}: StudySchemaEntryTemplatesProps): JSX.Element {
  return (
    <div className="simpleDivTable simpleDivTable--wide u-large-spacing-bottom">
      <FieldTableHeader
        isDisabled={!writable}
        onAddField={onAddClick}
        shouldShowTooltip={true}
        title="Entry Templates"
        onAddToolTip="Edit available entry templates"
        toolTipIcon="edit"
      />
      <div>
        {entryTemplates.length ? (
          <TagEntryTemplates entryTemplates={entryTemplates} />
        ) : (
          <div className="simpleDivTable-row">
            <div className="simpleDivTable-cell simpleDivTable-cell--emptyMessage">
              Any entry template is allowed on this study
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
